import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useQuery } from "react-query";
import { API } from "../../config/api";
import image from "../../assets/img/empty.svg";

import Navigasi from "../../components/Navigasi";

function UserHome() {
  document.title = "Home";
  const [query, setQuery] = useState("");

  let { data: products } = useQuery("productsCache", async () => {
    const response = await API.get("/products");
    return response.data.data;
  });
  console.log(products);

  return (
    <>
      <Navigasi />
      <Container className="userhome-section">
        <p className="fw-bold fs-4 p-product">Product</p>
        {products?.length !== 0 ? (
          <>
            <input
              type="text"
              className="form-control bg-dark text-white mb-3"
              placeholder="Cari Nama Product ..."
              style={{ width: "20%" }}
              onChange={(event) => setQuery(event.target.value)}
            />
            <Row className="mb-5">
              {products
                ?.filter((data) => {
                  if (query === "") {
                    return data;
                  } else if (
                    data.name.toLowerCase().includes(query.toLowerCase())
                  ) {
                    return data;
                  }
                })
                .map((product) => (
                  <Col md={4} lg={3} key={product.id} className="mb-5">
                    <Link to={`/detail-product/${product.id}`}>
                      <Card className="card-product">
                        <Card.Img variant="top" src={product.image} />
                        <Card.Body>
                          <Card.Title className="product-title fw-bold">
                            {product.name}
                          </Card.Title>
                          <Card.Text className="product-price">
                            <span>Rp. {product.price}</span> <br />
                            <span>Stok: {product.qty}</span>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Link>
                  </Col>
                ))}
            </Row>
          </>
        ) : (
          <>
            <div className="text-center pt-5">
              <img
                src={image}
                className="img-fluid my-5"
                style={{ width: "40%" }}
                alt="noData"
              />
              <div className="mt-3 mb-5">No data product</div>
            </div>
          </>
        )}
      </Container>
    </>
  );
}

export default UserHome;
